import {css} from 'styled-components'

export const SnippetsStyles = css`
  .product-list-snippet {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    
    & > *:not(style) {
      width: 310px;
      display: flex;
    }
  }

  .product-snippet {
    width: 310px;
    display: flex;
  }
`